<template>
  <div>
    <div class="page-header clear-filter" filter-color="black">
      <parallax
        class="page-header-image"
        style="background-image:url('/img/galleries/large/motorbike/P8110869-Pano.jpg'); background-position: 0% 75%"
      ></parallax>
      <div class="container">
        <h1 class="title">Trips, tours & travels</h1>
      </div>
    </div>
    <div class="section">
      <div class="container galleries">
        <router-link class="gallery-tile" :to="`/trip/${id}`" v-for="(gallery, id) in trips" :key="gallery.name">
          <card>
            <img slot="image" class="card-img-top" :src="gallery.tileImage">
            <h5 class="card-text">{{gallery.name}}</h5>
          </card>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from '@/components';
  import trips from '@/trips/trips';
  import { metaTitles, metaDescriptions, metaImage } from '@/utils/meta';

  export default {
    name: 'trips',
    bodyClass: 'profile-page',
    metaInfo: {
      title: 'Trips',
      meta: [
        ...metaTitles('Trips'),
        ...metaDescriptions('Overview of the past trips & travels'),
        ...metaImage('/img/trips/thumbs/motorbike/PA080398-Enhanced-small.jpg', 640, 480),
      ],
    },
    components: {
      Card,
    },
    data() {
      return {
        trips,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .galleries {
    padding: 0 50px;
    display: grid;
    grid-template-columns: calc(50% - 35px) calc(50% - 35px);
    gap: 70px;
    justify-items: center;
    place-items: start;

    @media (max-width: 768px) {
      grid-template-columns: 100%;
      gap: 50px;
    }
  }

  .card-text {
    text-align: center;
    color: black;
    text-transform: uppercase;
  }

  .gallery-tile {
    width: 100%;
    cursor: pointer;
    display: flex;

    &:hover {
      text-decoration: none;
    }

    &::before {
      content: "";
      display: inline-block;
      width: 1px;
      height: 0;
      padding-bottom: calc(100% / (4/3) + 65px);
    }

    .card {
      width: 100%;
      min-height: 100%;
      flex-grow: 1;
      margin-bottom: 0;

      img {
        aspect-ratio: 4/3;
      }
    }
  }

</style>
